<mat-accordion class="custom-accordion">
  <mat-expansion-panel>
      <mat-expansion-panel-header>
          <mat-panel-title>
              {{ 'dashboard.goalProgress' | translate }} 
          </mat-panel-title>
      </mat-expansion-panel-header>
      <ion-card-content class="ion-no-padding" >
          <ion-list mode="ios" lines="full" class="ion-no-margin goal-progress">
              <ion-item *ngFor="let process of processes">
                  <ion-label>
                      <h2>{{ process.title }}</h2>
                      <p>
                          <span>{{ process.deadline | date : 'dd/MM/yyyy' }}</span>
                          <span *ngIf="hasStatus(process)">
              <ion-text [color]="getStatusColor(process)">
                <ion-icon class="bp-circle-fill"></ion-icon>
                  {{ 'dashboard.deadlineIn' | translate }}
                  {{ getDeadlineDateCount(process) }}
                  {{ getDeadlineDateTranslationKey(process) | translate }} !!
              </ion-text>
            </span>
                      </p>
                      <div class="progress-bar-container"
                           [ngClass]="{
              'primary': getProgressBarColor(process, 'primary'),
              'success': getProgressBarColor(process, 'success'),
              'danger': getProgressBarColor(process, 'danger'),
              'warning': getProgressBarColor(process, 'warning')
            }">
                          <div class="prohress-bar">
                              <span [ngStyle]="getProgressBarLength(process)"></span>
                          </div>
                          <div class="progress-bar-status">
                              {{ process.currentProgress }}%
                          </div>
                      </div>
                  </ion-label>
                  <ion-button color="light" mode="ios" slot="end" (click)="viewGoalModal(process)">
                      <ion-icon color="primary" class="bp-view"></ion-icon>
                  </ion-button>
              </ion-item>
          </ion-list>
      </ion-card-content>
  </mat-expansion-panel>
    
</mat-accordion>